import React from "react";
import { Menu, MenuItem } from "@mui/material";

function RightClickMenu({ anchorEl, open, onClose, menuItems, anchorPosition }) {
    return (
        <Menu
            anchorEl={anchorEl}
            anchorReference={anchorPosition ? "anchorPosition" : "anchorEl"}
            anchorPosition={anchorPosition || undefined}
            open={open}
            onClose={onClose}
            onClick={(e) => e.stopPropagation()}
        >
            {menuItems.map((item, index) => (
                <MenuItem
                    key={index}
                    onClick={() => {
                        onClose();
                        if (item.onClick) item.onClick();
                    }}
                >
                    {item.label}
                </MenuItem>
            ))}
        </Menu>
    )
}

export default RightClickMenu